import React, { FC } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import styles from './styles';

interface IStackedBox {
  children: React.ReactNode;
  backgroundColor: string;
  showStacks?: boolean;
  sx?: SxProps<Theme>;
  stackHeight?: number;
  stackGap?: number;
}

const StackedBox: FC<IStackedBox> = ({
  backgroundColor,
  stackHeight = 5,
  stackGap = 2,
  children,
  showStacks,
  sx,
}) =>
  (
    <Box sx={[styles.container, sx] as SxProps<Theme>}>
      {children}
      {showStacks && (
      <Box sx={styles.cards}>
        <Box
          sx={[
            styles.cardColor(backgroundColor),
            styles.card,
            styles.cardOne,
            { height: stackHeight, mt: `${stackGap}px` },
          ]}
        />
        <Box
          sx={[
            styles.cardColor(backgroundColor),
            styles.card,
            styles.cardTwo,
            { height: stackHeight, mt: `${stackGap}px` },
          ]}
        />
      </Box>
      )}
    </Box>
  );

export default StackedBox;
